// src/pages/Employee/CreateEmployee/StepIndicator.tsx
import React from 'react';
import { Check } from 'react-feather';
import { WizardStepMeta } from '../../types/employee.types';

interface StepIndicatorProps {
  steps: WizardStepMeta[];
  currentIndex: number;
  furthestIndex: number; // deepest step the user has reached — earlier steps are clickable
  stepHasError: Record<number, boolean>;
  onStepClick: (index: number) => void;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
  steps,
  currentIndex,
  furthestIndex,
  stepHasError,
  onStepClick,
}) => {
  return (
    <div className="step-indicator mb-4">
      <div className="d-flex align-items-start" style={{ overflowX: 'auto' }}>
        {steps.map((step, index) => {
          const isCompleted = index < currentIndex;
          const isCurrent = index === currentIndex;
          const isClickable = index <= furthestIndex;
          const hasError = stepHasError[index];

          let circleClass = 'bg-light text-muted border';
          if (isCompleted) circleClass = hasError ? 'bg-danger text-white' : 'bg-success text-white';
          if (isCurrent) circleClass = 'bg-primary text-white';

          return (
            <React.Fragment key={step.key}>
              <div
                className="d-flex flex-column align-items-center text-center flex-shrink-0"
                style={{ width: 128, cursor: isClickable ? 'pointer' : 'default' }}
                onClick={() => isClickable && onStepClick(index)}
              >
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center fw-bold ${circleClass}`}
                  style={{ width: 36, height: 36, fontSize: 14, transition: 'all .15s ease' }}
                >
                  {isCompleted && !hasError ? <Check size={18} /> : index + 1}
                </div>
                <div className={`small mt-2 fw-semibold ${isCurrent ? 'text-primary' : 'text-dark'}`}>
                  {step.label}
                </div>
                <div className="text-muted d-none d-md-block" style={{ fontSize: 11 }}>
                  {step.description}
                </div>
              </div>

              {index < steps.length - 1 && (
                <div
                  className={index < currentIndex ? 'bg-success' : 'bg-light'}
                  style={{ height: 2, flex: 1, marginTop: 17, minWidth: 24 }}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;